/**
 * Whether the Trip Designer can book a hotel from a one-night availability
 * search, for its cards and map popups.
 *
 * The availability API deliberately keeps a hotel it cannot sell in the list —
 * with `rooms: []` and the binding `minimumStay` — so the card can explain why
 * (DmcHotelSource.computePrice) instead of showing a bare price. An included
 * hotel legitimately carries no sellable room, so it is never unbookable.
 *
 * The compose search always spans exactly one night (TripDesigner builds
 * endAt = startAt + 1 day), so any minimum above 1 is the blocking reason. A
 * stay one night short stays selectable — the agent may well be about to
 * extend it — so the card warns rather than blocks. An empty room list for any
 * OTHER reason (allotment, stop-sale) is a hard no the agent cannot resolve by
 * picking different days, and keeps its disabled CTA.
 */
export function getHotelBookability(hotel, { isIncluded = false } = {}) {
  const isUnbookable =
    !isIncluded && Array.isArray(hotel?.rooms) && hotel.rooms.length === 0;
  const minimumStay = Number(hotel?.minimumStay ?? 0);
  const isMinStayUnmet = isUnbookable && minimumStay > 1;

  return {
    minimumStay,
    isMinStayUnmet,
    isBlocked: isUnbookable && !isMinStayUnmet,
  };
}
